import { message } from 'antd';
import axios from 'axios';
import i18n from '../i18n';

export const setupAxiosInterceptor = () => {
  // Response interceptor to handle authentication errors globally
  axios.interceptors.response.use(
    (response) => {
      // Return successful responses as-is
      return response;
    },
    (error) => {
      // Handle authentication errors
      if (error.response?.status === 401) {
        // Don't redirect for isLoggedIn endpoint - let the component handle it
        const isLoggedInEndpoint = error.config?.url?.includes('/users/isLoggedIn');

        if (!isLoggedInEndpoint) {
          // Show toast notification with translation
          message.error(i18n.t('errors.sessionExpired'));

          // Redirect to login page after a short delay to allow user to see the message
          setTimeout(() => {
            window.location.href = '/';
          }, 1500);
        }
      }

      // Reject the promise to maintain error handling in components
      return Promise.reject(error);
    },
  );
};
